import { render, staticRenderFns } from "./GoldPriceCompact.vue?vue&type=template&id=10c8fc9e"
import script from "./GoldPriceCompact.vue?vue&type=script&lang=js"
export * from "./GoldPriceCompact.vue?vue&type=script&lang=js"
import style0 from "./GoldPriceCompact.vue?vue&type=style&index=0&id=10c8fc9e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports